import { BaseClass } from "./decision.model";

export class SurveyQuestionOption extends BaseClass {
  public description: string;
  public surveyQuestionId: string;
}
